module.exports = __webpack_public_path__ + "static/media/footer_logo.029b23a9.svg";